/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from 'react';
import { Col, Row, Alert } from 'react-bootstrap';
import { toHeaderCase } from 'js-convert-case';

export interface IStatusCompProps {
  profileStatus?: 'verified' | 'rejected' | 'submitted';
  profileStatusDescription?: string;
}
export const StatusComp = (props: IStatusCompProps) => {
  const { profileStatus, profileStatusDescription } = props;

  const _renderDescription = () => {
    if (profileStatusDescription) {
      return (
        <p className="fs-6 text-dark mb-0 w-100 align-justify">
          {profileStatusDescription}
        </p>
      );
    }
    return null;
  };

  const _renderTitleIf = () => {
    if (profileStatus) {
      return (
        <p className="m-0">
          {'KYC Status:' + ' ' + toHeaderCase(profileStatus ?? '')}
        </p>
      );
    }
  };

  return (
    <Row>
      <Col xs="auto" className="px-3">
        <Alert
          variant={
            profileStatus === 'verified'
              ? 'success'
              : profileStatus === 'submitted'
              ? 'warning'
              : 'danger'
          }
          className="p-2 w-100"
        >
          {_renderTitleIf()}
          {_renderDescription()}
        </Alert>
      </Col>
    </Row>
  );
};

StatusComp.defaultProps = {
  profileStatus: '',
  profileStatusDescription: '',
};
